// extracted by mini-css-extract-plugin
module.exports = {"code":"style_code__R7p01"};